import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { Spin, Pagination, Empty, notification } from "antd";
import ModalCapcha from "../../components/ModalCapcha";
import { searchBangAdv } from "../../redux/actions/searchFilter";
import { getValueFromUrl } from "../../utils/getValueFromUrl";
import { searchBang, saveSearchValue } from "../../redux/actions/search";
import { GetCapCha } from "../../services/search";

import Cookies from "js-cookie";
import {BASE_URL} from "../../requests/APIConfig";
import ModalReCapcha from "../../components/ModelReCapcha";

const mapStateToProps = (state) => ({
  certSearch: state.searchReducer,
  searchFilter: state.searchFilterReducer,
});

function ContentLayout({
  searchBang,
  certSearch,
  loading,
  setLoading,
  searchFilter,
  saveSearchValue,
  searchBangAdv,
}) {
  const history = useHistory();

  const { searchedCerts, pageSize, total } = certSearch;
  const [image, setImage] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [page, setPage] = useState(Number(getValueFromUrl(history).pageNum));

  // const changePage = async (pageNum) => {
  //   try {
  //     if (Cookies.get("code")) {
  //       setLoading(true);
  //       const params = getValueFromUrl(history);
  //       const res = await searchBang({
  //         params: {
  //           ...params,
  //           pageNum,
  //           captcha: Cookies.get("code"),
  //         },
  //         callback: async () => {
  //           const resData = await GetCapCha({
  //             width: 200,
  //             height: 80,
  //           });

  //           if (resData) {
  //             setImage(
  //               `data:image/jpeg;base64,${Buffer.from(
  //                 resData.data,
  //                 "binary"
  //               ).toString("base64")}`
  //             );
  //             setIsModalVisible(true);
  //           }
  //         },
  //       });
  //       setLoading(false);
  //       if (res) {
  //         const search = new URLSearchParams({
  //           ...params,
  //           pageNum,
  //         }).toString();
  //         history.push({
  //           pathname: "/main",
  //           search,
  //         });
  //       }
  //       setParams({ ...params, pageNum });
  //     } else {
  //       const resData = await GetCapCha({
  //         width: 200,
  //         height: 80,
  //       });

  //       if (resData) {
  //         setImage(
  //           `data:image/jpeg;base64,${Buffer.from(
  //             resData.data,
  //             "binary"
  //           ).toString("base64")}`
  //         );
  //         setIsModalVisible(true);
  //       }
  //     }
  //   } catch (error) {
  //     notification.error({
  //       description: "Đã có lỗi xảy ra!",
  //     });
  //   }
  // };

  // const searchData = async (captcha) => {
  //   const res = await searchBang({
  //     params: {
  //       ...params,
  //       captcha,
  //     },
  //     callback: () => {},
  //   });
  //   if (res) {
  //     setParams({ ...params, pageNum: params.pageNum });
  //     const search = new URLSearchParams({
  //       ...params,
  //       pageNum: params.pageNum,
  //     }).toString();
  //     setIsModalVisible(false);
  //     Cookies.set("code", captcha);
  //     history.push({
  //       pathname: "/main",
  //       search,
  //     });
  //   }
  // };

  const detailDiploma = (cert) => {
    const regex = /\//gi;
    const keyword = cert.soVaoSo?.replace(regex, "-");

    const params = getValueFromUrl(history);
    let objectData = {
      keyword: params?.keyword,
    };
    if (params.hvt) {
      objectData = { ...objectData, name: params.hvt };
    }
    if (params?.nam) {
      objectData = { ...objectData, year: params?.nam };
    }
    if (params?.donViId) {
      objectData = { ...objectData, donViId: params?.donViId };
    }
    if (params?.pageNum) {
      objectData = { ...objectData, pageNum: params?.pageNum };
    }
    if (params?.pageSize) {
      objectData = { ...objectData, pageSize: params?.pageSize };
    }

    const search = new URLSearchParams({
      ...objectData,
      soVaoSo: keyword,
      bangId: cert?.id,
    }).toString();

    history.push({
      pathname: `/detail`,
      search,
    });
  };

  const onSearch = async (pageNum) => {
    if (searchFilter?.keyword) {
      setPage(pageNum);
      try {
        if (!Cookies.get("code")) {
          // const resData = await GetCapCha({
          //   width: 200,
          //   height: 80,
          // });
          // if (resData) {
          //   setImage(
          //     `data:image/jpeg;base64,${Buffer.from(
          //       resData.data,
          //       "binary"
          //     ).toString("base64")}`
          //   );
          //   setIsModalVisible(true);
          // }
          setIsModalVisible(true);
        } else {
          handleSearch(pageNum);
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      notification.warning({
        description: "Nhập từ khoá tìm kiếm !",
      });
      return;
    }
  };

  const handleSearch = async (pageNum) => {
    setLoading(true);
    if (searchFilter?.keyword) {
      try {
        if (Cookies.get("code")) {
          // const captcha = Cookies.get("code");
          if (searchFilter.visible) {
            const res = await searchBangAdv({
              params: {
                keyword: searchFilter?.keyword,
                pageNum: pageNum ? pageNum : 1,
                pageSize: 5,
                // captcha,
                hvt: searchFilter?.name,
                nam: searchFilter?.year,
                idtruong: searchFilter?.donViId,
              },
              callback: () => {
                onSearch();
              },
            });
            setLoading(false);
            if (res) {
              // Cookies.set("code", captcha);
              saveSearchValue({
                keyword: searchFilter?.keyword,
                pageNum: pageNum ? pageNum : 1,
                pageSize: 5,
              });
              let objectData = {
                pageNum: pageNum ? pageNum : 1,
                pageSize: 5,
                keyword: searchFilter?.keyword,
              };
              if (searchFilter?.name) {
                objectData = {
                  ...objectData,
                  hvt: searchFilter?.name,
                };
              }
              if (searchFilter?.year) {
                objectData = {
                  ...objectData,
                  nam: searchFilter?.year,
                };
              }
              if (searchFilter?.donViId) {
                objectData = {
                  ...objectData,
                  donViId: searchFilter?.donViId,
                };
              }
              const search = new URLSearchParams(objectData).toString();
              setIsModalVisible(false);
              history.push({
                pathname: "/main",
                search,
              });
            }
          } else {
            const res = await searchBang({
              params: {
                keyword: searchFilter?.keyword,
                pageNum: pageNum ? pageNum : 1,
                pageSize: 5,
                // captcha,
              },
              callback: () => {
                onSearch();
              },
            });
            if (res) {
              setLoading(false);
              // Cookies.set("code", captcha);
              saveSearchValue({
                keyword: searchFilter?.keyword,
                pageNum: pageNum ? pageNum : 1,
                pageSize: 5,
              });
              const search = new URLSearchParams({
                keyword: searchFilter?.keyword,
                pageNum: pageNum ? pageNum : 1,
                pageSize: 5,
              }).toString();
              setIsModalVisible(false);
              history.push({
                pathname: "/main",
                search,
              });
            }
          }
        } else {
          // const resData = await GetCapCha({
          //   width: 200,
          //   height: 80,
          // });
          // if (resData) {
          //   setImage(
          //     `data:image/jpeg;base64,${Buffer.from(
          //       resData.data,
          //       "binary"
          //     ).toString("base64")}`
          //   );
          //   setIsModalVisible(true);
          // }
          setIsModalVisible(true);
        }
      } catch (error) {
        setLoading(false);
        notification.error({
          description: "Đã có lỗi sảy ra",
        });
      }
    } else {
      notification.warning({
        description: "Nhập từ khoá tìm kiếm !",
      });
      return;
    }
  };

  useEffect(() => {
    setPage(Number(getValueFromUrl(history).pageNum));
  });

  return (
    <Fragment>
      <div className="col-lg-1" />
      <div className="col-12 col-sm-12 col-md-12 col-lg-10">
        <Spin spinning={loading}>
          <div
            className="mb-3"
            style={{
              cursor: (searchedCerts || []).length > 0 ? "pointer" : "",
              paddingBottom: 48,
            }}
          >
            {(searchedCerts || []).length > 0 ? (
              <div>
                {searchedCerts.map((cert) => (
                  <div
                    key={cert.id}
                    onClick={() => detailDiploma(cert)}
                    className="mb-3"
                    style={{
                      boxShadow: "0 1px 6px 0 rgba(0,0,0,.16)",
                      borderRadius: 8,
                      boxSizing: "border-box",
                    }}
                  >
                    <div className="row">
                      <div className="col-md-4 col-lg-4">
                        <div className="d-flex align-items-center justify-content-center p-2">
                          <img
                            className="img-fluid"
                            // src={`https://apistaging.jbcert.vn${cert.duongDanFileAnh}`}
                            src={`${BASE_URL}${cert.duongDanFileAnh}`}
                            alt={cert.duongDanFileAnh}
                            style={{ border: "1px solid #f0f0f0" }}
                          />
                        </div>
                      </div>

                      <div className="col-md-8 col-lg-8">
                        <div
                          className="d-flex align-items-center align-items-center p-3 h-100"
                          style={{ lineHeight: "1.6" }}
                        >
                          <div style={{ color: "#5F6368" }}>
                            <div className="mb-3">
                              <h3
                                style={{
                                  cursor: "pointer",
                                  fontSize: 20,
                                  fontWeight: 600,
                                }}
                              >
                                <span>{cert.hoVaTen}</span>
                              </h3>
                            </div>

                            <div className="mb-2">
                              <h3>{cert.loaiBang}</h3>
                            </div>

                            <div className="mb-2">
                              <span>{cert.truongHoc}</span>
                            </div>

                            <div className="mb-2">
                              <code className="mr-1">{cert.soHieu}</code>
                              <span>-</span>
                              <span className="ml-1">{cert.soVaoSo}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

                <Pagination
                  current={page}
                  pageSize={pageSize}
                  total={total}
                  onChange={onSearch}
                />
              </div>
            ) : (
              <Empty />
            )}
          </div>
        </Spin>
      </div>
      <div className="col-lg-1" />
      {isModalVisible && (
        <ModalReCapcha
          setIsModalVisible={setIsModalVisible}
          isModalVisible={isModalVisible}
        />
      )}
      {/*{isModalVisible ? (*/}
      {/*  <ModalCapcha*/}
      {/*    image={image}*/}
      {/*    setIsModalVisible={setIsModalVisible}*/}
      {/*    isModalVisible={isModalVisible}*/}
      {/*    callback={() => {*/}
      {/*      onSearch(page);*/}
      {/*    }}*/}
      {/*    setImage={setImage}*/}
      {/*  />*/}
      {/*) : null}*/}
    </Fragment>
  );
}

export default connect(mapStateToProps, {
  searchBang,
  saveSearchValue,
  searchBangAdv,
})(ContentLayout);

// setLoading(true);
// try {
//   const res = await searchBang({
//     params: { ...params, pageNum },
//     callback: () => {},
//   });

//   if (res) {
//     setParams({ ...params, pageNum });
//     setLoading(false);

//     const search = new URLSearchParams({
//       ...params,
//       pageNum,
//     }).toString();

//     history.push({
//       pathname: "/main",
//       search,
//     });
//   }
// } catch (error) {}
